import Vue from 'vue';
import { Tabs, TabPane, Button, Input } from 'element-ui';

Vue.use(Button);
Vue.use(TabPane);
Vue.use(Tabs);
Vue.use(Input);
